var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'display': _vm.installBtn}),attrs:{"id":"wrapperInstall"}},[_c('div',{staticClass:"button",on:{"click":function($event){return _vm.installer()}}},[_vm._v("Установить на рабочий стол")])])
}
var staticRenderFns = []

export { render, staticRenderFns }